import { errorNotify } from "@/plugins/functions";

export function orderExport(id, shop, partner){
   this.$loading(true);
   this.$http
      .post(`orders/export`, { id: id, shop_id:shop.id, partner_id:partner.id })
      .then(() => {
         this.$notify({
            title: "Отправили запрос партнеру",
            message: "Данные успешно обновились",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
         });
         this.$store.dispatch("setLastUpdate", new Date());
         this.partner = null;
         this.shop = null;
         this.isUpload = false;
      })
      .catch((error) => {
         errorNotify(error, this.$notify);
      })
      .finally(() => {
         setTimeout(() => {
            this.$loading(false);
         }, 400);
      });
}

